/**
 * SetPosition Module
 * スクロール位置に応じて要素にクラスを追加
 */
export class SetPosition {
  constructor() {
    this.elements = document.querySelectorAll('.js-set-position');
    this.scrollHandler = null;
    this.resizeHandler = null;
    this.scrollTimer = null;
    this.resizeTimer = null;
    this.threshold = 0.5;
    
    if (this.elements.length > 0) {
      this.init();
    }
  }
  
  init() {
    this.checkPositions();
    this.setupScrollHandler();
    this.setupResizeHandler();
  }
  
  /**
   * スクロールハンドラーを設定（スロットル付き）
   */
  setupScrollHandler() {
    this.scrollHandler = () => {
      if (this.scrollTimer) {
        return;
      }
      
      this.scrollTimer = requestAnimationFrame(() => {
        this.checkPositions();
        this.scrollTimer = null;
      });
    };
    
    window.addEventListener('scroll', this.scrollHandler, { passive: true });
  }
  
  /**
   * リサイズハンドラーを設定（デバウンス付き）
   */
  setupResizeHandler() {
    this.resizeHandler = () => {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      
      this.resizeTimer = setTimeout(() => {
        this.checkPositions();
        this.resizeTimer = null;
      }, 150);
    };
    
    window.addEventListener('resize', this.resizeHandler, { passive: true });
  }
  
  /**
   * 各要素の位置をチェック
   */
  checkPositions() {
    const windowHeight = window.innerHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const thresholdPosition = scrollTop + windowHeight * this.threshold;
    
    this.elements.forEach((element) => {
      // 既にクラスが付いている場合はスキップ（パフォーマンス最適化）
      if (element.classList.contains('is-active')) {
        return;
      }
      
      const rect = element.getBoundingClientRect();
      
      // 1. 要素がウィンドウの50%の位置を通過しているかチェック
      const elementTop = rect.top + scrollTop;
      const elementBottom = elementTop + rect.height;
      const isAtThreshold = elementTop <= thresholdPosition && elementBottom >= thresholdPosition;
      
      // 2. 要素の下端がウィンドウ内に入ったかチェック
      const isBottomInView = rect.bottom <= windowHeight && rect.bottom > 0;
      
      if (isAtThreshold || isBottomInView) {
        element.classList.add('is-active');
      }
    });
  }
  
  /**
   * イベントリスナーを削除
   */
  destroy() {
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
      this.scrollHandler = null;
    }
    
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
      this.resizeHandler = null;
    }
    
    if (this.scrollTimer) {
      cancelAnimationFrame(this.scrollTimer);
      this.scrollTimer = null;
    }
    
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = null;
    }
  }
}
